export const capitalizeFirstLetter = (value: string) =>
  value?.charAt(0).toUpperCase() + value?.slice(1).toLowerCase();

export const capitalizeLocationName = (location: string) => {
  return location
    ?.split(" ")
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    ?.join(" ");
};
